const deepMerge = (existingState, newState) => {
  if (typeof existingState !== 'object' || existingState === null) {
    return newState
  }

  const output = { ...existingState }

  for (const key in newState) {
    if (newState.hasOwnProperty(key)) {
      const sourceValue = newState[key]
      const targetValue = existingState[key]

      if (typeof sourceValue === 'object' && sourceValue !== null && !Array.isArray(sourceValue)) {
        output[key] = deepMerge(targetValue, sourceValue)
      } else {
        output[key] = sourceValue
      }
    }
  }

  return output
}

export const updateZustandState = (existingState, newState) => {
  return deepMerge(existingState, newState)
}
